export default __webpack_public_path__ + "static/media/Logo.04577dc6.jpg";